<template>
<v-card color="primary" class="pa-1 ma-1 elevation-7">
  <v-toolbar  dense class="primary--text">
    <v-toolbar-title class="subheading">{{groupTitle}}</v-toolbar-title>
  </v-toolbar>
</v-card>
</template>
<script>
export default {
  name: 'groupHeader',
  props: {
    groupTitle: {
      required: false,
      type: String
    },
    groupColSpan: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
    }
  }
}
</script>
